import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'

export const RuleHeader = styled(Typography)({
  fontWeight: 700,
  fontSize: '16px',
  textAlign: 'center',
  position: 'sticky',
  top: 0,
})

export const RuleInfoWrapper = styled(Box)({
  display: 'flex',
  flexWrap: 'nowrap',
  flexDirection: 'row',
  justifyContent: 'space-around',
  alignItems: 'center',
  padding: ' 1rem',
})
export const RuleInfoContent = styled(Box)({
  display: 'flex',
  alignItems: 'center',
})

export const RuleDescription = styled(Typography)({
  wordBreak: 'break-word',
  position: 'relative',
  overflowWrap: 'break-word',
  whiteSpace: 'pre-wrap',
  color: '#193766',
})

export const RuleItem = styled(Typography)({
  wordBreak: 'break-word',
  position: 'relative',
  overflowWrap: 'break-word',
  whiteSpace: 'pre-wrap',
  color: '#193766',
})
